import { Component, Input } from '@angular/core';
import { ClaimStatus } from 'src/app/sakp/model/departure-reading';
import { ViolationService } from 'src/app/sakp/services/violations.service';
import { colorizeClaimStatusBackground } from 'src/app/sakp/util/css-utils';


@Component({
  selector: 'app-violations-marker2',
  templateUrl: './violations-marker2.component.html',
  styleUrls: ['./violations-marker2.component.scss']
})
export class ViolationsMarker2Component {

  @Input()
  private claims: Record<number, ClaimStatus>;
  @Input()
  private claimsDate: Date | null;


  constructor(
    private violationService: ViolationService,
  ) { }


  getViolations(): number[] {
    return this.claims != null ? Object.keys(this.claims).map(Number) : [];
  }

  colorize(violation: number): string {
    const status = this.claims[violation];
    return colorizeClaimStatusBackground(status);
  }

  getViolationSymbol(idViolation: number): string {
    const violations = this.violationService.getByDate(this.claimsDate);
    if (!violations) return idViolation + '';
    const violation = violations.getViolationById(idViolation);
    return violation?.symbol ?? idViolation + ''; // TODO: obsługa ewentualnych nadpisań z violation.i18n
  }
}
